import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { STATUS_CODES } from "@src/config/constant";
import CommonServiceId from "@src/services/CommonServiceId";
import { APIResponse } from "@store/types/Common";

const CommonIdSlice = createSlice({
    name: 'commonId',
    initialState: {
        userDetail: {},
        newMMVlist:{},
        city: [],
        state: [],
        district: [],
        documentFormObj : [],
        stateWithCity: [],
        bankList: []
    },
    reducers: {
        userDetail: (state, action) => {
            state.userDetail = action.payload
        },
        setNewMMVlist: (state, action: PayloadAction<Record<string, any>>) => {
            state.newMMVlist = {...state.newMMVlist,...action.payload};
        },
        city: (state, action) => {
            state.city = action.payload;
        },
        state: (state, action) => {
            state.state = action.payload;
        },
        setDistrict: (state, action: any) => {
            state.district = action.payload;
        },
        documentFormObj: (state, action) => {
            state.documentFormObj = action.payload;
        },
        stateWithCity: (state, action) => {
            state.stateWithCity = action.payload;
        },
        bankList: (state, action) => {
            state.bankList = action.payload;
        },
        district: (state, action) => {
            state.district = action.payload;
        }
    }
})

export default CommonIdSlice.reducer

export const { userDetail,setNewMMVlist, city, state ,setDistrict, documentFormObj, stateWithCity,bankList, district} = CommonIdSlice.actions

export const getUserDetail = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getUserDetail(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(userDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}
export const saveFeedBack = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.saveFeedback(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getNotificationCountId = (params:any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getNotificationCount(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
export const getNotificationListId = (params:any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getNotificationList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
export const readNotificationHistoryId = (params:any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.readNotificationHistory(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getFormFields = (params:any, headers?: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getFormFields(params, headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getBrandList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getBrandList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getParentModelList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getParentModelList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getVersionList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getVersionList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getOldCarPrice = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getOldCarPrice(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}


export const getLeadDocumentList = (params:any) => async(dispatch:any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getLeadDocumentList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)

                dispatch(documentFormObj(response.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getDistrictList = (params: object, headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getDistrictList(params, headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                resolve(response.data)
                dispatch(setDistrict(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getStateWiseCityList = (headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getStateWiseCity(headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(stateWithCity(data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getStateCityList = (headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getStateCityList(headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(city(data.city))
                dispatch(state(data.state))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}


export const docs_upload = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.docs_upload(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                resolve(response.data)
                //dispatch(setDistrict(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
export const getShortFileUrl = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.docs_upload(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                resolve(response.data)
                //dispatch(setDistrict(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
export const getDocumentListing = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getDocumentListing(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getAgentleadHistory = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getAgentleadHistory(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getQuotationList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getQuotationList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getCreditPointListing = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getCreditPointListing(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const updateCreditPoint = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.updateCreditPoint(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getAgencyBankList = (headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getAgencyBankList(headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                const data = response.data?.data || [];
                resolve(response.data)
                dispatch(bankList(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getStateList = (headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getStateList(headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(state(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getCityList = (params: object, headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getCityList(params, headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(city(data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getLocalityList = (params: object, headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonServiceId.getLocalityList(params, headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(district(data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
